module.exports = "mutation userChangeRole($userId:ID!,$role:String!){userChangeRole(user:$userId,role:$role){id role}}"